import React from 'react';
import { Dialog, DialogTitle, DialogContent, IconButton, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CreateVariantForm from './CreateVariantForm';
import { GroupInterface } from '../../types';

interface CreateVariantModalProps {
  open: boolean;
  onClose: () => void;
  group: GroupInterface;
  onVariantCreated: () => void;
}

function CreateVariantModal({ open, onClose, group, onVariantCreated }: CreateVariantModalProps): React.JSX.Element {
  const handleVariantCreated = (): void => {
    onVariantCreated();
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        יצירת קורס חדש
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 2 }}>
          <CreateVariantForm
            group={group}
            onVariantCreated={handleVariantCreated}
          />
        </Box>
      </DialogContent>
    </Dialog>
  );
}

export default CreateVariantModal; 